function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.125 7H.875a.875.875 0 010-1.75h26.25a.875.875 0 110 1.75zm0 8.75H.875a.875.875 0 010-1.75h26.25a.875.875 0 110 1.75zm0 8.75H.875a.875.875 0 010-1.75h26.25a.875.875 0 110 1.75z",
  fill: "currentColor"
});

function SvgIconHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjggMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI3LjEyNSA3SC44NzVhLjg3NS44NzUgMCAwMTAtMS43NWgyNi4yNWEuODc1Ljg3NSAwIDExMCAxLjc1ek0yNy4xMjUgMTUuNzVILjg3NWEuODc1Ljg3NSAwIDAxMC0xLjc1aDI2LjI1YS44NzUuODc1IDAgMTEwIDEuNzV6TTI3LjEyNSAyNC41SC44NzVhLjg3NS44NzUgMCAwMTAtMS43NWgyNi4yNWEuODc1Ljg3NSAwIDExMCAxLjc1eiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+Cg==";
export { SvgIconHamburger as ReactComponent };